module.exports = __webpack_public_path__ + "static/media/sweetpotato.6bea9679.png";